import { render, staticRenderFns } from "./subCategoryUpdate.vue?vue&type=template&id=11b9a54d&"
import script from "./subCategoryUpdate.vue?vue&type=script&lang=js&"
export * from "./subCategoryUpdate.vue?vue&type=script&lang=js&"
import style0 from "./subCategoryUpdate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports